import React,{ useContext } from 'react';
import Marquee from "react-fast-marquee";

import './Skills.css'

import { ThemeContext } from '../../contexts/ThemeContext';
import { skillsData } from '../../data/skillsData'
import { skillsImage } from '../../utils/skillsImage'

function Skills(props) {
	
	const skillIcons = {
  lumion: '🖥️',            // rendu 3D temps réel
  autocad: '📏',           // dessin technique 2D/3D
  sketchup: '🧱',          // modélisation simple, architecture
  photoshop: '🖌️',         // retouche / textures
  revit: '🏗️',             // BIM / maquette numérique
  archicad: '🏛️',          // BIM aussi mais oriented Archi
  '3dsmax': '📦',          // modélisation + rendu avancé
  twinmotion: '🌇',        // rendu architectural immersif
  rhino: '🐏',             // forme libre + NURBS
  grasshopper: '🔧',       // programmation visuelle / paramétrique
  illustrator: '🎨',       // schémas, logos, vectoriel
  indesign: '📚',          // plaquettes, books, docs
  autocadcivil3d: '🛣️',   // infrastructure / génie civil
  excel: '📊',             // tableaux, calculs, métrés
  word: '📝',              // rapports, dossiers techniques
  powerpoint: '🎞️',       // présentations
  msproject: '📈',         // planification / Gantt
  navisworks: '🧭',        // coordination / clash detection BIM
};




    const { theme } = useContext(ThemeContext);
    console.log(props.competences);
    const skillBoxStyle = {
        backgroundColor: theme.secondary,
        boxShadow: `0px 0px 30px ${theme.primary30}`
    }

    return (
        <div id ="skills"className="skills" style={{backgroundColor: theme.secondary}}>
            <div className="skillsHeader">
                <h2 style={{color: theme.primary}}>Compétences Logicielles DAO</h2>
            </div>
            <div className="skillsContainer">
                <div className="skill--scroll">
                    <Marquee 
                        gradient={false} 
                        speed={80} 
                        pauseOnHover={true}
                        pauseOnClick={true} 
                        delay={0}
                        play={true} 
                        direction="left"
                    >
                        {props.competences.map((skill, id) => {
							  const icon = skillIcons[skill.Titre.toLowerCase()] || '🛠️'; // par défaut
							  return (
								<div className="skill--box" key={id} style={skillBoxStyle}>
								  <h3 style={{ color: theme.tertiary }}>
									<span style={{ marginRight: '0.5rem' }}>{icon}</span>
									{skill.Titre}
								  </h3>
								  <p style={{ color: theme.tertiary }}>Niveau : {skill.Niveau} / 5</p>
								</div>
							  );
							})}		

                    </Marquee>
                </div>
            </div>
        </div>
    )
}

export default Skills
